"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../..");
var constants_1 = require("../../../../constants");
var utils_1 = require("../../../../pages/utils/utils");
// eslint-disable-next-line import/no-named-as-default-member
var PridatZpracovateleUkonuPopup_1 = __importDefault(require("./components/PridatZpracovateleUkonuPopup"));
var ZpracovatelListItem_1 = __importDefault(require("./components/ZpracovatelListItem"));
var PridatZpracovateleField_1 = require("./PridatZpracovateleField");
var StyledLabel = styled_components_1.default(function (props) { return react_1.default.createElement(__1.FormLabel, __assign({}, props)); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: flex-start;\n"], ["\n  align-self: flex-start;\n"])));
var StyledPopup = styled_components_1.default(function (props) { return react_1.default.createElement(__1.Popup, __assign({}, props)); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &-content {\n    padding: 2em 0 0 0;\n  }\n"], ["\n  &-content {\n    padding: 2em 0 0 0;\n  }\n"])));
var StyledDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 1em;\n"], ["\n  margin-bottom: 1em;\n"])));
exports.Title = styled_components_1.default.h2(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0;\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 140%;\n  padding: 0 30px 20px;\n  color: #000000;\n"], ["\n  margin: 0;\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 140%;\n  padding: 0 30px 20px;\n  color: #000000;\n"])));
var PridatZpracovateleUkonuField = function (_a) {
    var _b;
    var name = _a.name, label = _a.label, isEdit = _a.isEdit, typUkonu = _a.typUkonu;
    var isOpen = __1.useBoolean(false);
    var _c = formik_1.useField(name), field = _c[0], meta = _c[1], helpers = _c[2];
    var token = __1.useToken();
    var value = field.value || [];
    var _d = __1.useCiselnik('ukonyRole'), data = _d.data, loading = _d.loading, error = _d.error;
    var _e = react_1.useState(), editIndex = _e[0], setEditIndex = _e[1];
    var _f = react_1.useState(), editValueZpracovatel = _f[0], setEditValueZpracovatel = _f[1];
    var _g = (token === null || token === void 0 ? void 0 : token.getDataFromToken()) || {}, roleIds = _g.roleIds, entityId = _g.entityId;
    var apiUrl = __1.useConfig().apiUrl;
    var getTlumocnikInfoJSON = __1.useGetJSON(apiUrl + "/TlumocnikInfo");
    var fopLogged = roleIds === null || roleIds === void 0 ? void 0 : roleIds.includes(constants_1.Role.tlumocnik);
    var getTLumocnik = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getTlumocnikInfoJSON({ idTlumocnik: entityId })];
                case 1:
                    response = _a.sent();
                    if (__1.isRight(response))
                        return [2 /*return*/, response.value];
                    return [2 /*return*/, null];
            }
        });
    }); };
    react_1.useEffect(function () {
        if (!isEdit && fopLogged) {
            getTLumocnik().then(function (tlumocnik) {
                var _a;
                if (tlumocnik) {
                    var tlumocnikValue = __assign({ idSubjekt: tlumocnik.id, role: { id: tlumocnik.druhOsoby === constants_1.TlumocniciDruhOsoby.tlumocnik ? __1.UkonyRoleOsoby.Tlumocnik : __1.UkonyRoleOsoby.Prekladatel }, druh: { id: constants_1.UkonyTypOsoby.FyzickaOsobaPodnikajici }, adresaSidla: (_a = tlumocnik.adresa) === null || _a === void 0 ? void 0 : _a.adresaText, titulPred: tlumocnik.titul, titulZa: tlumocnik.titulZa, odmenyNahrady: {} }, tlumocnik);
                    helpers.setValue(__spreadArrays(value, [tlumocnikValue]));
                }
            });
        }
    }, []);
    var handleAddZpracovatel = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var odmenyItem;
        return __generator(this, function (_a) {
            odmenyItem = __assign(__assign({}, item), { odmenyNahrady: item.idSubjekt.toString() === entityId ? {} : undefined });
            if (editIndex === undefined)
                helpers.setValue(__spreadArrays(value, [odmenyItem]));
            else {
                value[editIndex] = odmenyItem;
                helpers.setValue(value);
            }
            isOpen.setFalse();
            return [2 /*return*/];
        });
    }); };
    var handleRemoveZpracovatel = function (index) {
        helpers.setValue(value.filter(function (item) { return ramda_1.indexOf(item, value) !== index; }));
    };
    var handleEdit = function (i) {
        setEditIndex(i);
        var editZpracovatel = value[i];
        setEditValueZpracovatel(editZpracovatel);
        isOpen.setTrue();
    };
    if (loading)
        return react_1.default.createElement(react_1.default.Fragment, null, "na\u010D\u00EDt\u00E1n\u00ED");
    return (react_1.default.createElement(__1.Field, { topAlign: true },
        ((_b = field.value) === null || _b === void 0 ? void 0 : _b.length) ? react_1.default.createElement(StyledLabel, { htmlFor: name }, label) : react_1.default.createElement(__1.FormLabel, { htmlFor: name }, label),
        react_1.default.createElement(PridatZpracovateleField_1.BorderDiv, { "$hasError": !!meta.error && !field.value },
            !!(value === null || value === void 0 ? void 0 : value.length) && (react_1.default.createElement(StyledDiv, null, value.map(function (item, index) { return (react_1.default.createElement(ZpracovatelListItem_1.default, { key: "zpracovatel-" + item.idSubjekt, nazev: react_1.default.createElement("strong", null, utils_1.getJmenoPrijmeni(item.jmeno, item.prijmeni, item.titulPred, item.titulZa)), item: item, onRemove: function () { return handleRemoveZpracovatel(index); }, onEdit: function () { return handleEdit(index); }, readOnly: fopLogged && entityId === item.idSubjekt.toString() })); }))),
            react_1.default.createElement(__1.LinkButton, { type: "button", className: "button", onClick: isOpen.setTrue },
                "P\u0159idat zpracovatele v p\u0159\u00EDpad\u011B spole\u010Dn\u00E9ho",
                ' ',
                typUkonu === constants_1.DruhyUkonu.PrekladatelskyUkon || typUkonu === constants_1.DruhyUkonu.RevizniPrekladatelskyUkon ? 'překladatelského' : 'tlumočnického',
                " \u00FAkonu"),
            react_1.default.createElement(StyledPopup, { open: isOpen.value, onClose: function () {
                    isOpen.setFalse();
                    setEditIndex(undefined);
                    setEditValueZpracovatel(undefined);
                } },
                react_1.default.createElement(exports.Title, null,
                    editIndex !== undefined ? 'Upravit' : 'Přidat',
                    " zpracovatele"),
                react_1.default.createElement(PridatZpracovateleUkonuPopup_1.default, { addZpracovatel: handleAddZpracovatel, zpracovatele: __spreadArrays(value), selectedZpracovatel: editValueZpracovatel, typUkonu: typUkonu })))));
};
PridatZpracovateleUkonuField.defaultProps = {
    isEdit: false,
};
exports.default = PridatZpracovateleUkonuField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
